import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["container", "expandable"];
  static values = { commentorId: Number };

  toggle(event) {
    event.preventDefault();

    this.expandableTarget.classList.toggle("d-none");
    this.expandableTarget.classList.toggle("bg-gray-200");
    this.containerTarget.classList.toggle("bg-gray-200");
    this.containerTarget.classList.toggle("collapsed");
  }
}
